import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL TYPES
export const typeList = (params = '') => Http.get(`/marketing-ad-types${serialize(params)}`)
export const typeCreate = (params = '') => Http.post('/marketing-ad-types', params)
export const typeByID = (params = '') => Http.get(`/marketing-ad-types/${params}`)
export const typeUpdate = (params = '') => Http.put(`/marketing-ad-types/${params.id}`, params)
export const typeDestroy = (params = '') => Http.delete(`/marketing-ad-types/${params.id}`)
